import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const LayoutContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
  minWidth: "100vw",
  width: "100vw",
  height: "100vh",
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  overflow: "hidden",
  backgroundColor:
    theme.palette.mode === "dark"
      ? theme.palette.background.default // Dark mode: #121212
      : theme.palette.grey[50], // Light mode: #F8F9FA
}));

export const MainContent = styled(Box, {
  shouldForwardProp: (prop) => prop !== "sidebarCollapsed",
})(({ theme, sidebarCollapsed }) => ({
  flexGrow: 1,
  marginLeft: sidebarCollapsed ? "45px" : "300px",
  padding: "12px",
  transition: "all 0.3s ease",
  backgroundColor:
    theme.palette.mode === "dark"
      ? theme.palette.background.default // Dark mode: #121212
      : "#ffffff", // Light mode: White
  minHeight: "calc(100vh - 48px)",
  width: "100%",
  position: "relative",
  overflowX: "hidden",
  overflowY: "auto",
  marginTop: "0",
}));
